import * as React from "react"
import LinktoFormButton from "../components/LinktoFormButton"
import Arrow from "../components/Arrow"
import gsap from "gsap"
import PageLinkFade from "./PageTransitionFade"
export default class Form extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      inputs: this.props.inputs,
      currentIndex: 0,
    }
    this.next = this.next.bind(this)
    this.prev = this.prev.bind(this)
    this.greyButton = this.greyButton.bind(this)
    this.unGreyButton = this.unGreyButton.bind(this)
  }

  componentDidMount() {
    document.querySelector("form").addEventListener("submit", this.handleSubmit)
    this.changeDisplayedInput()
    const inputs = document.querySelectorAll("input:not(#netify-form)")
    document.addEventListener("keydown", e => {
      if (e.key === "Enter") {
        if (this.state.currentIndex === this.state.inputs.length - 1 && inputs[this.state.currentIndex] !== "") {
          document.querySelector("#submit-form").click()
        } else {
          this.next(e)
        }
      }
    })
    inputs.forEach((input, index) => {
      input.addEventListener("input", e => {
        if (e.target.value !== "" && index === this.state.currentIndex && this.state.currentIndex !== this.state.inputs.length - 1) {
          this.unGreyButton("next")
        } else if (e.target.value === "" && index === this.state.currentIndex && this.state.currentIndex !== this.state.inputs.length - 1) {
          this.greyButton("next")
        } else if (e.target.value !== "" && this.state.currentIndex === this.state.inputs.length - 1) {
          this.unGreyButton("submit-form")
        } else if (e.target.value === "" && this.state.currentIndex === this.state.inputs.length - 1) {
          this.greyButton("submit-form")
        }
      })
    })
  }
  componentWillUnmount() {
    document.querySelector("form").removeEventListener("submit", this.handleSubmit)
  }

  handleSubmit = e => {
    window.lintrk("track", { conversion_id: 14585460 })
    e.preventDefault()
    let myForm = document.querySelector("form")
    let formData = new FormData(myForm)
    fetch("/", {
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      body: new URLSearchParams(formData).toString(),
    })
      .then(() => {
        document.querySelector(".linkPointer").click()
      })
      .catch(error => console.log(error))
  }

  prev() {
    const length = this.state.inputs.length

    if (this.state.currentIndex !== 0 && this.state.currentIndex !== length - 1) {
      this.unGreyButton("next")
      const oldIndex = this.state.currentIndex
      this.setState({ currentIndex: this.state.currentIndex - 1 }, () => {
        this.changeDisplayedInput()

        this.setDisplayNoneIndex(oldIndex)
        if (this.state.currentIndex === 0) {
          this.greyButton("prev")
        }
      })
    } else if (this.state.currentIndex === length - 1) {
      const oldIndex = this.state.currentIndex
      this.setState({ currentIndex: this.state.currentIndex - 1 }, () => {
        this.changeDisplayedInput()

        let tl = gsap.timeline({ onStart: (this.unGreyButton("next"), this.greyButton("submit-form")) })

        tl.to("#submit-form", { opacity: 0, duration: 0.4, ease: "ease" })
        tl.to("#submit-form", { display: "none" })
        tl.to("#next", { display: "flex" }, "<")
        tl.to("#next", { visibility: "visible" }, "<")
        tl.to("#next", { opacity: 1, duration: 0.4, ease: "ease" }, "<")

        this.setDisplayNoneIndex(oldIndex)
        if (this.state.currentIndex === 0) {
          this.greyButton("prev")
        }
      })
    }
  }

  next(e) {
    if (e) {
      e.preventDefault()
    }
    let input = document.querySelector(`[data-input-value="${this.state.currentIndex}"]`)

    const length = this.state.inputs.length
    const required = this.state.inputs[this.state.currentIndex].required

    const oldIndex = this.state.currentIndex

    if ((required && input.value) || required === false) {
      this.setState({ currentIndex: this.state.currentIndex + 1 }, () => {
        let input = document.querySelector(`[data-input-value="${this.state.currentIndex}"]`)

        this.changeDisplayedInput()
        this.setDisplayNoneIndex(oldIndex)

        this.unGreyButton("prev")

        if (this.state.currentIndex === length - 1 && input.value !== "") {
          this.unGreyButton("submit-form")
          let tl = gsap.timeline()
          tl.to("#submit-form", { display: "flex" })
          tl.to("#next", { opacity: 0, duration: 0.4, ease: "ease" }, "<")
          tl.to("#submit-form", { visibility: "visible" }, "<")
          tl.to("#submit-form", { opacity: 0 }, "<")
          tl.to("submit-form", { position: "relative" }, "<")
          tl.to("#submit-form", { opacity: 1, duration: 0.4, ease: "ease" }, "+=0.1")
          tl.to("#next", { visibility: "hidden" })
        } else if (this.state.currentIndex === length - 1) {
          let tl = gsap.timeline({ onStart: (this.greyButton("next"), this.greyButton("submit-form")) })
          tl.to("#submit-form", { display: "flex" })
          tl.to("#next", { opacity: 0, duration: 0.4, ease: "ease" }, "<")
          tl.to("#submit-form", { visibility: "visible" }, "<")
          tl.to("#submit-form", { opacity: 0 }, "<")
          tl.to("submit-form", { position: "relative" }, "<")
          tl.to("#submit-form", { opacity: 1, duration: 0.4, ease: "ease" }, "+=0.1")
          tl.to("#next", { visibility: "hidden" })
        } else if (!this.state.inputs[this.state.currentIndex].required) {
          this.unGreyButton("next")
        } else {
          if (required && input.value === "") {
            this.greyButton("next")
          }
        }
      })
    }
  }

  /*
   * css Functions
   */

  changeDisplayedInput() {
    const input = document.querySelector(`[data-input-num="${this.state.currentIndex}"]`)
    input.style.display = "flex"
    input.querySelector("input").focus()
  }
  setDisplayNoneIndex(oldIndex) {
    const prevInput = document.querySelector(`[data-input-num="${oldIndex}"]`)
    prevInput.style.display = "none"
  }

  greyButton(buttonId) {
    const button = document.querySelector(`#${buttonId}`)
    button.style.cursor = "default"
    const arrow = document.querySelector(`button#${buttonId} svg`)
    arrow.classList.replace("f-2A2A2A", "f-502A")
    arrow.classList.replace("f-i-1-e", "f-i-1-b")
    const text = document.querySelector(`button#${buttonId} div`)
    text.classList.replace("c-2A2A2A", "c-502A")
    if (buttonId === "next") {
      text.classList.replace("m-a-1-e", "m-a-1-b")
    } else if (buttonId === "submit-form") {
      text.classList.replace("m-a-1-e", "m-a-1-b")
    } else {
      text.classList.replace("m-a-1-e-0", "m-a-1-b-0")
    }
  }
  unGreyButton(buttonId) {
    const button = document.querySelector(`#${buttonId}`)
    button.style.cursor = "pointer"
    const arrow = document.querySelector(`#${buttonId} svg `)

    //COLORS
    arrow.classList.replace("f-502A", "f-2A2A2A")
    arrow.classList.replace("f-i-1-b", "f-i-1-e")
    const text = document.querySelector(`button#${buttonId} div`)

    text.classList.replace("c-502A", "c-2A2A2A")

    if (buttonId === "next") {
      text.classList.replace("m-a-1-b", "m-a-1-e")
    } else if (buttonId === "submit-form") {
      text.classList.replace("m-a-1-b", "m-a-1-e")
    } else {
      text.classList.replace("m-a-1-b-0", "m-a-1-e-0")
    }
  }

  /*
   * html render function
   */

  render() {
    const inputs = this.state.inputs.map((input, index) => {
      return (
        <div data-input-num={index} className='display-none h-84 flex flex-c' key={index}>
          <h4 className='m-b-20'>{input.title}</h4>
          <div className='flex-grow-1 '>
            <input id={`input${index + 1}`} placeholder={input.placeholder} type={input.type} required={input.required} name={input.name} data-input-value={index} />
          </div>
        </div>
      )
    })

    let links
    if (this.props.memberships) {
      links = (
        <div className={this.props.linksClass}>
          <LinktoFormButton text='Memberships' submitContact className={this.props.memberhsipsClass} />
        </div>
      )
    } else if (this.props.events) {
      links = (
        <div className={this.props.linksClass}>
          <LinktoFormButton text='Events' submitContact className={this.props.memberhsipsClass} />
        </div>
      )
    } else {
      links = (
        <div className={"flex flex-r m-b-60 br  " + this.props.linksClass}>
          <div>
            <LinktoFormButton text='General' to='/contact' submitContact className={this.props.generalClass} />
          </div>

          <div className='p-l-20'>
            <LinktoFormButton text='Memberships' membership to='/memberships' className={this.props.memberhsipsClass} classNameDiv='grey' classNameArrow='f-black0' />
          </div>
        </div>
      )
    }
    return (
      <>
        <PageLinkFade to='/contactSubmission' className='linkPointer o-p-0' />
        <form className={"over-h" + this.props.className} name={this.props.name} method='POST' data-netlify='true'>
          <input type='hidden' name='form-name' value={this.props.name} id='netify-form'></input>
          <div className={"p-b-65 " + this.props.classWrapper}>
            <h4 className={"m-b-20 " + this.props.classEnquiry}>ENQUIRY TYPE</h4>
            <h4 className={"m-b-360 d-n-b display-none " + this.props.classEnquiryMembership}>MEMBERSHIP ENQUIRIES</h4>
            {links}
          </div>
          <div className='p-b-20'>{inputs}</div>
          <div className='flex flex-r'>
            <div className='w-33-33-p'>
              <button className='flex flex-center-v  relative' id='prev' onClick={this.prev} type='button'>
                <Arrow className='f-502A absolute ab-l-0 f-i-1-b' />
                <div className='  button c-502A p-r-20 m-a-1-b-0'> Prev </div>
              </button>
            </div>
            <div className='w-33-33-p flex flex-center-h' id='index-track'>
              <h4>
                {this.state.currentIndex + 1}/{this.state.inputs.length}
              </h4>
            </div>
            <div className='w-33-33-p flex al-end flex-c relative'>
              <button className='flex flex-center-v o-p-0 absolute li-conversion' id='submit-form' type='submit'>
                <Arrow className='f-502A absolute ab-l-0 f-i-1-b ab-l-40-n' />
                <div className=' button c-502A m-a-1-b '> Submit </div>
              </button>
              <button className='flex flex-center-v relative ' id='next' type='button' onClick={this.next}>
                <Arrow className='f-502A absolute ab-l-0 f-i-1-b ab-l-40-n' />
                <div className=' button c-502A m-a-1-b '> Next </div>
              </button>
            </div>
          </div>
        </form>
      </>
    )
  }
}
